import { useState, Fragment, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { FaPhone, FaPen, FaWhatsapp } from 'react-icons/fa';
import PaymentModal from '../payment/PaymentModal';
import PaymentHistoryModal from '../payment/PaymentHistoryModal';
import { Dialog, Transition } from '@headlessui/react';

const CustomerRow = ({ customer, index, refresh }) => {
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [showHistoryModal, setShowHistoryModal] = useState(false);
  const [showWorkModal, setShowWorkModal] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);


useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const barClass =
    customer.work_percentage >= 80
      ? 'bg-green-600'
      : customer.work_percentage >= 50
      ? 'bg-yellow-400'
      : 'bg-red-600';

  let workDetails = [];
  try {
    workDetails =
      typeof customer.work_process_details === 'string'
        ? JSON.parse(customer.work_process_details)
        : customer.work_process_details || [];
  } catch (e) {
    console.warn('Invalid work_process_details format');
  }


  const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

  return (
    <>
      <tr className="border-b last:border-none">
        <td className="px-3 py-2 font-semibold">{index + 1}</td>
        <td className="px-3 py-2">
          <strong className="block">{customer.customer_name}</strong>
          {customer.domain && (
            <a
              href={`http://${customer.domain}`}
              target="_blank"
              rel="noreferrer"
              className="text-blue-600 hover:underline block truncate max-w-xs"
              title={customer.domain}
            >
              🌐 {customer.domain}
            </a>
          )}
          <div className="mt-1">
            📞 {customer.contact_number}
            <br />
            🏢 {customer.business_name}
          </div>
        </td>

        <td className="px-3 py-2">
          {customer.done_date
            ? new Date(customer.done_date).toLocaleDateString('en-IN', {
                day: '2-digit',
                month: 'short',
                year: 'numeric',
              })
            : '-'}
        </td>

        <td className="px-3 py-2">
          <div>
            <span className="font-semibold">Sales:</span> {customer.salesman_name || 'N/A'}
          </div>
          <div>
            <span className="font-semibold">Developer:</span> {customer.developer_name || 'N/A'}
          </div>
          <div>
            <span className="font-semibold">Co-Dev:</span> {customer.codeveloper_names || 'N/A'}
          </div>
        </td>

        <td className="px-3 py-2">
          {Array.isArray(workDetails) && workDetails.length > 0 ? (
            <>
              <ul className="mb-1 list-disc list-inside max-h-20 overflow-auto text-sm">
                {workDetails.slice(-2).map((r, i) => (
                  <li key={i}>
                    <strong>{r.date || ''}:</strong> {r.text || ''}
                  </li>
                ))}
              </ul>
              {workDetails.length > 2 && (
                <button
                  onClick={() => setShowWorkModal(true)}
                  className="text-sm text-blue-600 hover:underline focus:outline-none"
                  type="button"
                >
                  View More
                </button>
              )}
            </>
          ) : (
            <em className="text-gray-500 text-sm">No Work Process</em>
          )}

          <div className="relative w-full h-5 mt-2 bg-gray-300 rounded border border-black">
            <div
              className={`h-full text-center text-white text-xs rounded ${barClass}`}
              style={{ width: `${customer.work_percentage}%` }}
            >
              {`${isNaN(Number(customer.work_percentage)) ? 0 : Number(customer.work_percentage)}%`}
            </div>
          </div>
        </td>

        <td className="px-3 py-2">
          <span className="text-green-700 font-bold block">
            ₹{parseFloat(customer.price || 0).toFixed(2)}
          </span>
          <span className="text-red-700 font-bold block">
            ₹{parseFloat(customer.due_amount || 0).toFixed(2)}
          </span>
        </td>

        <td className="px-3 py-2 flex gap-2">
          <a
            href={`tel:${customer.contact_number}`}
            className="bg-green-600 hover:bg-green-700 text-white p-1 rounded text-sm inline-flex items-center justify-center"
            aria-label="Call customer"
          >
            <FaPhone />
          </a>
          <a
            href={`https://wa.me/${customer.contact_number}`}
            target="_blank"
            rel="noreferrer"
            className="bg-green-600 hover:bg-green-700 text-white p-1 rounded text-sm inline-flex items-center justify-center"
            aria-label="WhatsApp customer"
          >
            <FaWhatsapp />
          </a>
        </td>

        <td className="px-3 py-2 relative" ref={dropdownRef}>
          <button
            onClick={toggleDropdown}
            className="text-xl px-2 py-1 rounded hover:bg-gray-200 focus:outline-none"
            aria-haspopup="true"
            aria-expanded={dropdownOpen}
            type="button"
          >
            ⋮
          </button>

          <Transition
            as={Fragment}
            show={dropdownOpen}
            enter="transition ease-out duration-150"
            enterFrom="opacity-0 translate-y-1"
            enterTo="opacity-100 translate-y-0"
            leave="transition ease-in duration-100"
            leaveFrom="opacity-100 translate-y-0"
            leaveTo="opacity-0 translate-y-1"
          >
            <ul
              className="absolute right-0 z-10 mt-2 w-40 bg-white border border-gray-300 rounded shadow-lg py-1 text-sm"
              role="menu"
              aria-orientation="vertical"
              aria-labelledby="menu-button"
              tabIndex={-1}
            >
              <li>
                <Link
                  to={`/dashboard/doneCustomers/${customer.id}/edit`}
                  onClick={() => setDropdownOpen(false)}
                  className="block px-4 py-2 hover:bg-gray-100"
                >
                  ✏️ Edit
                </Link>
              </li>
              <li>
                <button
                  onClick={() => {
                    alert('Delete logic here');
                    setDropdownOpen(false);
                  }}
                  className="block w-full text-left px-4 py-2 text-red-600 hover:bg-gray-100"
                >
                  🗑️ Delete
                </button>
              </li>
              <li>
                <button
                  onClick={() => {
                    setShowHistoryModal(true);
                    setDropdownOpen(false);
                  }}
                  className="block w-full text-left px-4 py-2 text-blue-600 hover:bg-gray-100"
                >
                  📜 View Payments
                </button>
              </li>
              <li>
                <button
                  onClick={() => {
                    setShowPaymentModal(true);
                    setDropdownOpen(false);
                  }}
                  className="block w-full text-left px-4 py-2 text-indigo-600 hover:bg-gray-100"
                >
                  💰 Update Payment
                </button>
              </li>
            </ul>
          </Transition>
        </td>
      </tr>

      {/* Work Details Modal */}
      <Transition appear show={showWorkModal} as={Fragment}>
        <Dialog
          as="div"
          className="fixed inset-0 z-20 overflow-y-auto"
          onClose={() => setShowWorkModal(false)}
          open={showWorkModal}
        >
          <div className="min-h-screen px-4 text-center bg-black bg-opacity-40">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="inline-block w-full max-w-md p-6 my-20 overflow-hidden text-left align-middle transition-all transform bg-white shadow-xl rounded-2xl">
                <Dialog.Title
                  as="h3"
                  className="text-lg font-medium leading-6 text-gray-900 mb-4"
                >
                  Work Details
                </Dialog.Title>
                <div className="max-h-60 overflow-auto">
                  {workDetails.length > 0 ? (
                    <ul className="list-disc list-inside space-y-1 text-sm">
                      {workDetails.map((r, i) => (
                        <li key={i}>
                          <strong>{r.date || ''}:</strong> {r.text || ''}
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <p className="text-gray-500 italic">No work details available.</p>
                  )}
                </div>
                <div className="mt-4 text-right">
                  <button
                    type="button"
                    className="inline-flex justify-center px-4 py-2 text-sm font-medium text-indigo-600 bg-indigo-100 rounded hover:bg-indigo-200 focus:outline-none"
                    onClick={() => setShowWorkModal(false)}
                  >
                    Close
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition>

      {/* Payment Modals */}
      {showPaymentModal && (
        <PaymentModal
          customer={customer}
          onClose={() => setShowPaymentModal(false)}
          onPaymentSuccess={() => {
            setShowPaymentModal(false);
            refresh();
          }}
        />
      )}

      {showHistoryModal && (
        <PaymentHistoryModal customer={customer} onClose={() => setShowHistoryModal(false)} />
      )}
    </>
  );
};

export default CustomerRow;



